export default __webpack_public_path__ + "static/media/question.75cd780c.svg";